"use strict";
// import React from 'react'
// import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts'
// import { fmtInt, fmtMs, fmtPct } from '../../utils/Utils'
// import { TimeseriesRow } from '../../utils/api/orm-metrics/orm-metrics.type'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSeriesChart = TimeSeriesChart;
// export function TimeSeriesChart({ data }: { data: TimeseriesRow[] }) {
//   return (
//     <div style={{ width: '100%', height: 320 }}>
//       <ResponsiveContainer>
//         <LineChart data={data}>
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="timestamp" tickFormatter={(ts) => new Date(ts).toLocaleTimeString()} />
//           <YAxis yAxisId="left" tickFormatter={fmtInt} />
//           <YAxis yAxisId="right" orientation="right" tickFormatter={fmtMs} />
//           <Tooltip
//             formatter={(val: any, name: string) => {
//               if (name === 'total_requests') return [fmtInt(val as number), 'Requêtes']
//               if (name === 'avg_query_time_ms') return [fmtMs(val as number), 'Temps moyen SQL']
//               if (name === 'slow_query_rate') return [fmtPct(val as number), 'Taux requêtes lentes']
//               if (name === 'avg_query_count') return [(val as number).toFixed(2), 'Requêtes SQL / appel']
//               return [val, name]
//             }}
//             labelFormatter={(ts) => new Date(ts as string).toLocaleString()}
//           />
//           <Legend />
//           <Line type="monotone" dataKey="total_requests" name="Requêtes" yAxisId="left" dot={false} />
//           <Line type="monotone" dataKey="avg_query_time_ms" name="Temps moyen SQL" yAxisId="right" dot={false} />
//           <Line type="monotone" dataKey="slow_query_rate" name="Taux lentes" yAxisId="right" dot={false} strokeDasharray="4 2" />
//         </LineChart>
//       </ResponsiveContainer>
//     </div>
//   )
// }
const react_1 = __importStar(require("react"));
const recharts_1 = require("recharts");
const Utils_1 = require("../../utils/Utils");
const DEFAULT_COLORS = {
    requests: '#4F8CFF', // bleu
    latency: '#FF8C4F', // orange
    slowRate: '#EC4899', // rose
    grid: 'rgba(255,255,255,0.08)',
};
function Dot({ cx, cy, fill }) {
    if (cx == null || cy == null)
        return null;
    return react_1.default.createElement("circle", { cx: cx, cy: cy, r: 2, fill: fill });
}
function Bullet({ color }) {
    return react_1.default.createElement("span", { style: {
            display: 'inline-block', width: 8, height: 8, borderRadius: 9999,
            marginRight: 8, backgroundColor: color, verticalAlign: 'middle'
        } });
}
function CustomTooltip({ active, payload, label, colors }) {
    if (!active || !(payload === null || payload === void 0 ? void 0 : payload.length))
        return null;
    // on sécurise les valeurs avec Number(...)
    const rows = payload.map((p) => {
        var _a;
        const key = p.dataKey;
        const raw = Number(p.value);
        if (key === 'total_requests')
            return { name: 'Requêtes', value: (0, Utils_1.fmtInt)(raw), color: colors.requests };
        if (key === 'avg_query_time_ms')
            return { name: 'Temps moyen SQL', value: (0, Utils_1.fmtMs)(raw), color: colors.latency };
        if (key === 'slow_query_rate')
            return { name: 'Taux requêtes lentes', value: (0, Utils_1.fmtPct)(raw), color: colors.slowRate };
        return { name: key, value: String((_a = p.value) !== null && _a !== void 0 ? _a : '—'), color: p.color || '#9aa4b2' };
    });
    return (react_1.default.createElement("div", { style: {
            background: 'rgba(18,26,50,.95)',
            color: '#E6EAF2',
            padding: '10px 12px',
            border: '1px solid #242d4a',
            borderRadius: 10,
            boxShadow: '0 8px 30px rgba(0,0,0,.35)',
            fontSize: 12,
            maxWidth: 320
        } },
        react_1.default.createElement("div", { style: { opacity: .8, marginBottom: 6 } }, new Date(label).toLocaleString()),
        rows.map((r) => (react_1.default.createElement("div", { key: r.name, style: { display: 'flex', alignItems: 'center', marginBottom: 4 } },
            react_1.default.createElement(Bullet, { color: r.color }),
            react_1.default.createElement("span", { style: { flex: 1, opacity: .9 } }, r.name),
            react_1.default.createElement("strong", null, r.value))))));
}
function TimeSeriesChart({ data, height = 320, palette }) {
    const colors = Object.assign(Object.assign({}, DEFAULT_COLORS), (palette || {}));
    // Normalisation douce si l’API renvoie des strings
    const series = (0, react_1.useMemo)(() => (data !== null && data !== void 0 ? data : []).map(d => {
        var _a, _b, _c;
        return (Object.assign(Object.assign({}, d), { total_requests: Number((_a = d.total_requests) !== null && _a !== void 0 ? _a : 0), avg_query_time_ms: Number((_b = d.avg_query_time_ms) !== null && _b !== void 0 ? _b : 0), slow_query_rate: Number((_c = d.slow_query_rate) !== null && _c !== void 0 ? _c : 0) }));
    }), [data]);
    return (react_1.default.createElement("div", { style: { width: '100%', height } },
        react_1.default.createElement(recharts_1.ResponsiveContainer, null,
            react_1.default.createElement(recharts_1.LineChart, { data: series, margin: { top: 8, right: 24, bottom: 8, left: 16 } },
                react_1.default.createElement("defs", null,
                    react_1.default.createElement("linearGradient", { id: "latencyGradient", x1: "0", y1: "0", x2: "0", y2: "1" },
                        react_1.default.createElement("stop", { offset: "0%", stopColor: colors.latency, stopOpacity: 0.35 }),
                        react_1.default.createElement("stop", { offset: "100%", stopColor: colors.latency, stopOpacity: 0 }))),
                react_1.default.createElement(recharts_1.CartesianGrid, { strokeDasharray: "3 3", stroke: colors.grid }),
                react_1.default.createElement(recharts_1.XAxis, { dataKey: "timestamp", tickFormatter: (ts) => new Date(ts).toLocaleTimeString(), tick: { fill: '#c7cfe0', fontSize: 12 }, axisLine: { stroke: '#242d4a' }, tickLine: { stroke: '#242d4a' } }),
                react_1.default.createElement(recharts_1.YAxis, { yAxisId: "left", tickFormatter: (v) => (0, Utils_1.fmtInt)(Number(v)), tick: { fill: '#9aa4b2', fontSize: 12 }, axisLine: { stroke: '#242d4a' }, tickLine: { stroke: '#242d4a' } }),
                react_1.default.createElement(recharts_1.YAxis, { yAxisId: "right", orientation: "right", tickFormatter: (v) => (0, Utils_1.fmtMs)(Number(v)), tick: { fill: '#9aa4b2', fontSize: 12 }, axisLine: { stroke: '#242d4a' }, tickLine: { stroke: '#242d4a' } }),
                react_1.default.createElement(recharts_1.Tooltip, { content: react_1.default.createElement(CustomTooltip, { colors: colors }) }),
                react_1.default.createElement(recharts_1.Legend, { wrapperStyle: { color: '#9aa4b2', paddingTop: 4 }, formatter: (value) => react_1.default.createElement("span", { style: { color: '#cfd7ea' } }, value) }),
                react_1.default.createElement(recharts_1.Line, { type: "monotone", dataKey: "total_requests", name: "Requ\u00EAtes", yAxisId: "left", stroke: colors.requests, strokeWidth: 2, dot: react_1.default.createElement(Dot, { fill: colors.requests }), activeDot: { r: 4 } }),
                react_1.default.createElement(recharts_1.Area, { yAxisId: "right", type: "monotone", dataKey: "avg_query_time_ms", name: "Temps moyen SQL (zone)", fill: "url(#latencyGradient)", stroke: "none", isAnimationActive: false }),
                react_1.default.createElement(recharts_1.Line, { type: "monotone", dataKey: "avg_query_time_ms", name: "Temps moyen SQL", yAxisId: "right", stroke: colors.latency, strokeWidth: 2, dot: react_1.default.createElement(Dot, { fill: colors.latency }), activeDot: { r: 4 } }),
                react_1.default.createElement(recharts_1.Line, { type: "monotone", dataKey: "slow_query_rate", name: "Taux lentes", yAxisId: "right", stroke: colors.slowRate, strokeDasharray: "6 4", strokeWidth: 2, dot: false, activeDot: { r: 4 } })))));
}
